export const UtilsTable = () => {


    const validateRowsTable = (item) => {

        if (item !== undefined && item !== null) {
            return item
        } else {
            return "---"
        }

    }

    return{
        validateRowsTable
    }

}